import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { AiAgentConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { AiAgentService } from './api/aiAgent.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class AiAgentApiModule {
    public static forRoot(configurationFactory: () => AiAgentConfiguration): ModuleWithProviders<AiAgentApiModule> {
        return {
            ngModule: AiAgentApiModule,
            providers: [ { provide: AiAgentConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: AiAgentApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('AiAgentApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
